import api from '../../../services/api';

/**
 * Assign a section to a team member
 */
export const assignSection = async (rfpId, sectionId, assignedToUserId, notes = '') => {
    return api.post(`/rfp/lead/${rfpId}/assign`, {
        section_id: sectionId,
        assigned_to_user_id: assignedToUserId,
        notes,
    });
};

/**
 * Unassign a section
 */
export const unassignSection = async (rfpId, sectionId, payload = {}) => {
    return api.post(`/rfp/lead/${rfpId}/sections/${sectionId}/unassign`, payload);
};

/**
 * Bulk assign sections
 */
export const bulkAssignSections = async (rfpId, assignments) => {
    return api.post(`/rfp/lead/${rfpId}/bulk-assign`, { assignments });
};

/**
 * Update section content
 */
export const updateSectionContent = async (rfpId, sectionId, payload) => {
    return api.patch(`/rfp/v1/${rfpId}/sections/${sectionId}/update`, payload);
};

/**
 * Update section status (Team Lead)
 * Supports Approve (54) or Request Revision (55) with revision_notes
 */
export const updateSectionStatus = async (rfpId, sectionId, statusCode, revisionNotes = undefined) => {
    const payload = {
        status: statusCode
    };
    if (revisionNotes !== undefined && revisionNotes !== null) {
        payload.revision_notes = revisionNotes;
    }
    return api.patch(`/rfp/lead/${rfpId}/sections/${sectionId}/status`, payload);
};

/**
 * Submit section for review (Team Member)
 */
export const submitSectionToLead = async (rfpId, sectionId) => {
    return api.post(`/rfp/employee/${rfpId}/sections/${sectionId}/submit`);
};

/**
 * Request clarification (Team Lead to Team Member)
 */
export const requestClarification = async (rfpId, sectionId, message) => {
    return api.post(`/rfp/lead/${rfpId}/sections/${sectionId}/clarification-request`, { message });
};

/**
 * Request deadline extension (Team Member)
 */
export const requestExtension = async (rfpId, sectionId, requestedDeadline, reason) => {
    return api.post(`/rfp/employee/${rfpId}/sections/${sectionId}/request-extension`, {
        requested_deadline: requestedDeadline,
        reason: reason
    });
};

/**
 * Handle section extension decision (Approve/Reject)
 */
export const handleSectionExtensionDecision = async (rfpId, sectionId, payload) => {
    return api.post(`/rfp/lead/v1/${rfpId}/sections/${sectionId}/extension-decision`, payload);
};

/**
 * Initiate a section action (e.g., generate a new section structure)
 */
export const initiateSectionAction = async (rfpId, instruction) => {
    return api.post(`/extraction/v1/${rfpId}/section-action`, { instruction });
};

/**
 * Confirm a section action (e.g., commit new sections)
 */
export const confirmSectionAction = async (rfpId, payload) => {
    return api.post(`/extraction/v1/${rfpId}/section-action/confirm`, payload);
};
